import { useEffect, useState } from 'react';
import { useGameStore } from '../../store/gameStore';
import type { FateCard } from '../../types';
import styles from './OwlPreview.module.css';

interface Props {
  cellId: number;
  cellName: string;
  cellPrice: number;
  onDecide: (buy: boolean) => void;
}

export default function OwlPreview({ cellId, cellName, cellPrice, onDecide }: Props) {
  const owlPreviewFate = useGameStore(s => s.owlPreviewFate);
  const [fateCard, setFateCard] = useState<FateCard | null>(null);

  useEffect(() => {
    const card = owlPreviewFate();
    setFateCard(card);
  }, [owlPreviewFate]);

  const categoryLabel = (cat: string) => {
    switch (cat) {
      case 'good': return '好运';
      case 'bad': return '厄运';
      case 'reverse': return '反转';
      default: return cat;
    }
  };

  const categoryClass = (cat: string) => {
    switch (cat) {
      case 'good': return styles.catGood;
      case 'bad': return styles.catBad;
      case 'reverse': return styles.catReverse;
      default: return '';
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <span className={styles.icon}>🦉</span>
          <span className={styles.title}>谨慎决策</span>
        </div>

        {fateCard ? (
          <div className={styles.fateSection}>
            <div className={styles.fateLabel}>命运预兆</div>
            <div className={styles.fateCard}>
              <span className={styles.fateEmoji}>{fateCard.emoji}</span>
              <div className={styles.fateInfo}>
                <span className={styles.fateName}>{fateCard.name}</span>
                <span className={`${styles.fateCat} ${categoryClass(fateCard.category)}`}>
                  {categoryLabel(fateCard.category)}
                </span>
              </div>
            </div>
            <p className={styles.fateDesc}>{fateCard.description}</p>
          </div>
        ) : (
          <div className={styles.loading}>窥探命运中...</div>
        )}

        <div className={styles.propertyInfo}>
          <span className={styles.propLabel}>地产</span>
          <span className={styles.propName}>{cellName}</span>
          <span className={styles.propPrice}>¥{cellPrice.toLocaleString()}</span>
        </div>

        <div className={styles.actions}>
          <button className={styles.btnBuy} onClick={() => onDecide(true)}>
            💰 购买
          </button>
          <button className={styles.btnPass} onClick={() => onDecide(false)}>
            放弃
          </button>
        </div>
      </div>
    </div>
  );
}
